export const TEST_ID = 'chemicalDetailSections';
